import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  Radio,
  FormGroup,
  RadioGroup,
  FormControlLabel,
  Stack,
  Chip,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import AddmultipleTables from "./Tables";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI302_4 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [chipsData, setChipsData] = useState("");
  const [unitsAll, SetUnit] = useState("");
  const [formData, setFormData] = useState({
    energyConsumption: "",
    reductionEnergy: "Yes",
    consumption: {
      process: {
        unit: "",
        remark: "",
        value: "",
      },
      conversion: {
        unit: "",
        remark: "",
        value: "",
      },
      change: {
        unit: "",
        remark: "",
        value: "",
      },
      operational: {
        unit: "",
        remark: "",
        value: "",
      },
    },
    includedReduction: [],
    reductionByEnergyType: "Yes",
    reductions: {
      fuel: {
        unit: "",
        remark: "",
        value: "",
      },
      electric: {
        unit: "",
        remark: "",
        value: "",
      },
      heat: {
        unit: "",
        remark: "",
        value: "",
      },
      colling: {
        unit: "",
        remark: "",
        value: "",
      },
      steam: {
        unit: "",
        remark: "",
        value: "",
      },
    },
    basisReductionBasis: "",
    standardsCalculation: "",
  });

  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));
  React.useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        SetUnit(
          res.data.data.GRI300.energyConsumption
            ?.totalFuelConsumptionNonRenewable?.unit
        );
        const response = res.data.data.GRI300.reductionofEnergy;
        setFormData({
          energyConsumption: response?.energyConsumption,
          reductionEnergy: response?.reductionEnergy || "Yes",
          consumption: {
            process: {
              unit: response?.consumption?.process?.unit,
              remark: response?.consumption?.process?.remark,
              value: response?.consumption?.process?.value,
            },
            conversion: {
              unit: response?.consumption?.conversion?.unit,
              remark: response?.consumption?.conversion?.remark,
              value: response?.consumption?.conversion?.value,
            },
            change: {
              unit: response?.consumption?.change?.unit,
              remark: response?.consumption?.change?.remark,
              value: response?.consumption?.change?.value,
            },
            operational: {
              unit: response?.consumption?.operational?.unit,
              remark: response?.consumption?.operational?.remark,
              value: response?.consumption?.operational?.value,
            },
          },
          includedReduction: response?.includedReduction,
          reductionByEnergyType: response?.reductionByEnergyType || "Yes",
          reductions: {
            fuel: {
              unit: response?.reductions?.fuel?.unit,
              remark: response?.reductions?.fuel?.remark,
              value: response?.reductions?.fuel?.value,
            },
            electric: {
              unit: response?.reductions?.electric?.unit,
              remark: response?.reductions?.electric?.remark,
              value: response?.reductions?.electric?.value,
            },
            heat: {
              unit: response?.reductions?.heat?.unit,
              remark: response?.reductions?.heat?.remark,
              value: response?.reductions?.heat?.value,
            },
            colling: {
              unit: response?.reductions?.colling?.unit,
              remark: response?.reductions?.colling?.remark,
              value: response?.reductions?.colling?.value,
            },
            steam: {
              unit: response?.reductions?.steam?.unit,
              remark: response?.reductions?.steam?.remark,
              value: response?.reductions?.steam?.value,
            },
          },
          basisReductionBasis: response?.basisReductionBasis,
          standardsCalculation: response?.standardsCalculation,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const inputData = [
    {
      defalut: "Reduction initiatives",
      colwidth: "28%",
      filedName: "consumption",
      fields: [
        {
          title: "Value",
          field: "value",
          type: "number",
        },
        {
          title: "Unit",
          field: "unit",
          type: "select",
        },
        {
          title: "Remark",
          field: "remark",
          type: "text",
        },
      ],
    },
    {
      defalut: "Types of energy included in the reductions",
      colwidth: "28%",
      filedName: "reductions",
      fields: [
        {
          title: "Value",
          field: "value",
          type: "number",
        },
        {
          title: "Unit",
          field: "unit",
          type: "select",
        },
        {
          title: "Remark",
          field: "remark",
          type: "text",
        },
      ],
    },
  ];

  const defaultSegments = [
    {
      title: "Process Redesign",
      type: "number",
      fieldName: "process",
      list: ["MJ", "GJ", "TJ", "KWH", "MWH", "GWH"],
    },
    {
      title: "Conversion and Retrofitting of Equipment",
      type: "number",
      fieldName: "conversion",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Changes in Behavior",
      type: "number",
      fieldName: "change",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Operational Changes",
      type: "number",
      fieldName: "operational",
      list: ["MJ", "GJ", "TJ"],
    },
  ];

  const defaultSegments1 = [
    {
      title: "Fuel (Petrol/Diesel or other)",
      type: "number",
      fieldName: "fuel",
      list: ["MJ", "GJ", "TJ", "KWH", "MWH", "GWH"],
    },
    {
      title: "Electricity",
      type: "number",
      fieldName: "electric",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Heating",
      type: "number",
      fieldName: "heat",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Cooling",
      type: "number",
      fieldName: "colling",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Steam",
      type: "number",
      fieldName: "steam",
      list: ["MJ", "GJ", "TJ"],
    },
  ];
  // const handleAdd = (e) => {
  //   setFormData((prev) => {
  //     console.log(prev?.includedReduction,"updatedArray")
  //     const updatedArray = prev?.includedReduction.includes(chipsData)
  //       ? prev.includedReduction // Keep the array unchanged if the value exists
  //       : [...prev?.includedReduction, chipsData]; // Add the value if it doesn't exist

  //     return {
  //       ...prev,
  //       ["includedReduction"]: updatedArray, // Update the 'engeryInclude' field
  //     };
  //   });
  // };
  const handleAdd = (e) => {
    if (!chipsData.trim()) return; // ✅ Prevent adding empty values

    setFormData((prev) => {
      const updatedArray = prev?.includedReduction.includes(chipsData.trim())
        ? prev.includedReduction // ✅ Keep unchanged if value exists
        : [...prev?.includedReduction, chipsData.trim()]; // ✅ Add if valid & unique
      return {
        ...prev,
        includedReduction: updatedArray, // ✅ Ensure correct key update
      };
    });
  };

  const handleDeleteLocation = (locationToDelete) => {
    setFormData((prevData) => ({
      ...prevData,
      includedReduction: prevData.includedReduction.filter(
        (loc) => loc !== locationToDelete
      ),
    }));
  };

  const handleData = (e) => {
    const { value } = e.target;
    setChipsData(value);
  };

  const handleChangeRadio = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [main]: value,
      ...(main === "reductionByEnergyType" &&
        value === "No" && {
          reductions: {
            fuel: { unit: "", remark: "", value: "" },
            electric: { unit: "", remark: "", value: "" },
            heat: { unit: "", remark: "", value: "" },
            colling: { unit: "", remark: "", value: "" }, // ✅ Fixed spelling (was `colling`)
            steam: { unit: "", remark: "", value: "" },
          },
        }),
      ...(main === "reductionEnergy" &&
        value === "No" && {
          consumption: {
            process: {
              unit: "",
              remark: "",
              value: "",
            },
            conversion: {
              unit: "",
              remark: "",
              value: "",
            },
            change: {
              unit: "",
              remark: "",
              value: "",
            },
            operational: {
              unit: "",
              remark: "",
              value: "",
            },
          },
        }), // If no sub-field, update main field
    }));
  };

  const handleChangeText = (e, type) => {
    const { name, value } = e.target;
    if (type === "number" && !/^\d*$/.test(value)) return;
    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      ...(sub
        ? { [main]: { ...prev[main], [sub]: value } } // If nested, update sub-field
        : { [main]: value }), // If no sub-field, update main field
    }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          submitted302_4: true,
          reductionofEnergy: { ...formData },
        })
          .then((res) => navigate(`/gri/gri300/302-5/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/302-5/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p className={styles.section_heading} style={{ textDecoration: "none" }}>
        302 : <span className={styles.main_heading_underline}>ENERGY</span>
      </p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        302-4 :{" "}
        <span className={styles.main_heading_underline}>
          Reduction of energy consumption
        </span>
      </p>
      <Box>
        <p className={styles.ques_heading}>
          a. Amount of reductions in energy consumption achieved as a direct
          result of conservation and efficiency initiatives
        </p>
        <Box sx={{ display: "flex", ml: "1rem" }}>
          <p className={styles.ques_heading}>
            Total reduction in energy consumption:
          </p>
          <TextField
            variant="outlined"
            name="energyConsumption"
            size="small"
            placeholder="Enter Number"
            sx={{ mt: "0.5rem", ml: 1 }}
            value={formData?.energyConsumption}
            onChange={(e) => handleChangeText(e, "number")}
            disabled={disabled}
          />
        </Box>
        <Box sx={{ display: "flex", ml: "1rem" }}>
          <p className={styles.ques_heading}>
            Do you have breakdown of the initiative taken for reduction of
            energy consumption:
          </p>
          <FormGroup
            component="fieldset"
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "1rem",
            }}
          >
            <RadioGroup
              aria-label="gender"
              defaultValue="female"
              name="reductionEnergy"
              value={formData?.reductionEnergy || ""}
              style={{ display: "flex", flexDirection: "row" }}
              onChange={handleChangeRadio}
              disabled={disabled}
            >
              {["Yes", "No"].map((item, index) => (
                <FormControlLabel
                  key={index} // Unique key for each label
                  value={item} // Set value to lowercased radio option
                  control={<Radio disabled={disabled} />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </FormGroup>
        </Box>
      </Box>
      {formData?.reductionEnergy === "Yes" && (
        <AddmultipleTables
          // title="c. Provide breakdown of energy consumed"
          inputData={[inputData[0]]}
          unitsAll={unitsAll}
          disabled1={true}
          defaultSegments={defaultSegments}
          {...{
            formData,
            setFormData,
            errors,
            setErrors,
            disabled: disabled,
            hide: hide
          }}
        />
      )}
      <p className={styles.ques_heading}>
        b. Types of energy included in the reductions
      </p>
      <Stack direction="row" spacing={1} mt={2}>
        {formData?.includedReduction
          ?.filter((location) => location?.trim() !== "")
          ?.map((location, index) => (
            <Chip
              key={index}
              label={location}
              onDelete={() => handleDeleteLocation(location)}
            />
          ))}
      </Stack>
      <Box sx={{ display: "flex", marginLeft: "1.2rem" , }}>
        <p className={styles.ques_heading} style={{marginTop: hide ? "-3rem" : "0"}}>
          Types of energy included in reduction:
        </p>
        <Box sx={{ display: "flex", width: "100%", marginTop: hide ? "-3rem" : "1.5rem" }}>
          {/* <TextField
            sx={{ mt: "0.5rem" }}
            variant="outlined"
            size="small"
            name="includedReduction"
            placeholder="Type here"
            //  value={formData?.includedReduction}
            value={chipsData||""}
            onChange={handleData}
          /> */}
          <Select
            sx={{
              height: "2rem",
              width: "50%",
              // border: "none",
              // boxShadow: "none", // Ensures no shadow appears
              // "& .MuiOutlinedInput-notchedOutline": {
              //   border: "none", // Removes default MUI border
              // },
              // "&:hover .MuiOutlinedInput-notchedOutline":
              //   {
              //     border: "none", // Ensures no border on hover
              //   },
              // "&.Mui-focused .MuiOutlinedInput-notchedOutline":
              //   {
              //     border: "none", // Removes border on focus
              //   },
            }}
            name="includedReduction"
            value={chipsData || ""}
            onChange={handleData}
            displayEmpty
            size="small"
            fullWidth
            disabled={disabled}
            // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
          >
            <MenuItem value="" disabled>
              <em>Select</em>
            </MenuItem>
            {[
              "Fuel (Petrol/Diesel or other)",
              "Electricity",
              "Heating",
              "Colling",
              "Steam",
            ]?.map((data, index) => (
              <MenuItem key={index} value={data}>
                {data}
              </MenuItem>
            ))}
          </Select>
          {!hide &&
          <Button
            // variant="contained"
            onClick={handleAdd}
            disabled={disabled}
            sx={{
              ml: "1rem",
              height: "2rem",
              // mt: "0.5rem",
              width: "20%",
              textTransform: "none",
              backgroundColor: "transparent",
              border: "1px solid #1C486B",
              color: "#1C486B",
            }}
          >
            <AddIcon />
            Add another
          </Button>
}
        </Box>
      </Box>
      <Box sx={{ display: "flex", marginLeft: "1.2rem", marginBottom: hide ? "-3rem" : "0" }}>
        <p className={styles.ques_heading}>
          Do you have breakdown of the reduction by energy type:
        </p>
        <FormGroup
          component="fieldset"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <RadioGroup
            aria-label="gender"
            defaultValue="female"
            name="reductionByEnergyType"
            value={formData?.reductionByEnergyType || ""}
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "1rem",
            }}
            onChange={handleChangeRadio}
            disabled={disabled}
          >
            {["Yes", "No"].map((item, index) => (
              <FormControlLabel
                key={index} // Unique key for each label
                value={item} // Set value to lowercased radio option
                control={<Radio disabled={disabled} />}
                label={item}
              />
            ))}
          </RadioGroup>
        </FormGroup>
      </Box>

      {formData?.reductionByEnergyType === "Yes" && (
        <AddmultipleTables
          // title="d. Provide breakdown of energy sold"
          inputData={[inputData[1]]}
          unitsAll={unitsAll}
          disabled1={true}
          defaultSegments={defaultSegments1}
          {...{
            formData,
            setFormData,
            errors,
            setErrors,
            disabled: disabled,
            hide : hide
          }}
        />
      )}
      <Box>
        <p className={styles.ques_heading}>
          c. Basis for calculating reductions in energy consumption, such as
          base year or baseline, including the rationale for choosing it.
        </p>

        <TextField
          placeholder="Enter Text"
          name="basisReductionBasis"
          sx={{ width: "98%", marginLeft: "1rem", marginTop: "-0.5rem" }}
          value={formData?.basisReductionBasis}
          onChange={(e) => handleChangeText(e, "text")}
          size="small"
          fullWidth
          disabled={disabled}
        />
        <p className={styles.ques_heading}>
          d. Standards, methodologies, assumptions, and/or calculation tools
          used
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          name="standardsCalculation"
          sx={{ width: "98%", marginLeft: "1rem", marginTop: "-0.5rem" }}
          value={formData?.standardsCalculation}
          onChange={(e) => handleChangeText(e, "text")}
          fullWidth
          disabled={disabled}
        />
      </Box>
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI302_4;
